import React, { Component } from 'react';
import { applicationContextActionCreator } from '../../store/actions/applicationContextActions';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import Fingerprint from 'fingerprintjs2';
import { authenticationResultEnum } from '../../utilities/enumerations';
import { AuthenticationService } from "../../services";

class AssureContext extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            returnUrl: '',
            working: false,
            initialAuthValues: {
                username: "",
                password: "",
                twoFactorAuthCode: "",
                fingerprint: ""
            }
        };
    }

    componentDidMount() {
        this.assureContext();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.currentUser !== prevProps.currentUser) {
            this.assureContext();
        }
    }

    assureContext() {
        const localThis = this;
        const authValues = { ...this.state.initialAuthValues };
        Fingerprint.get(function (components) {
            var murmur = Fingerprint.x64hash128(components.map(function (pair) { return pair.value }).join(), 31);
            authValues.fingerprint = murmur;
            localThis.setState({ initialAuthValues: authValues }, () => localThis.assureUser());
        });
    }

    async assureUser() {
        if (this.props.currentUser === null) {
            // try to get user based on cookie
            let exists = await this.checkForPersistedUser();
            if (!exists) {
                let location = this.props.location;
                let returnUrl = location.pathname;
                if (location.search !== '') {
                    returnUrl = returnUrl + encodeURIComponent(location.search);
                }

                var gotoLocation = '/login'
                if (returnUrl != '' && returnUrl != '/') {
                    gotoLocation = gotoLocation + `?returnUrl=${returnUrl}`;
                }
                this.props.history.push(gotoLocation);
            }
        }
    }

    async checkForPersistedUser() {

        var authService = new AuthenticationService();
        var result = authService.login(this.state.initialAuthValues)
            .then(result => {
                if (result.authResult == authenticationResultEnum.Success) {
                    this.props.updateCurrentUser(result.model);
                    return true;
                } else {
                    return false;
                }
            })
            .catch(err => {
                return false;
            });
        return await result;
    }





    //async assureContext() {
    //    if (this.props.applicationContext.currentUser === null) {
    //        let location = this.props.location;
    //        let returnUrl = location.pathname;
    //        if (location.search !== '') {
    //            returnUrl = returnUrl + encodeURIComponent(location.search);
    //        }
    //        this.setState({ returnUrl: returnUrl }, async () => await this.assureUserContext());
    //    }
    //}

    //async getFingerprint() {
    //    if (!this.state.working) {
    //        const localThis = this;
    //        Fingerprint.get(function (components) {
    //            var murmur = Fingerprint.x64hash128(components.map(function (pair) { return pair.value }).join(), 31);
    //            localThis.setState({ fingerprint: murmur, working: true }, async () => await localThis.assureUserContext());
    //        });
    //    }
    //}

    //async assureUserContext() {

    //    var fingerprint = this.state.fingerprint;
    //    var authService = new AuthenticationService();
    //    var result = await authService.getUser({ fingerprint: fingerprint });
    //    // if I got a successful result - then update current user
    //    if (result.result) {
    //        this.setState({ working: false }, () => this.props.updateCurrentUser(result.model));
    //    } else {
    //        // since I didn't forward to login page.
    //        var gotoLocation = '/login'
    //        if (this.state.returnUrl != '') {
    //            gotoLocation = gotoLocation + `?returnUrl=${this.state.returnUrl}`;
    //        }
    //        this.setState({ working: false }, () => this.props.history.push(gotoLocation));
    //    }
    //}

    render() {
        return (
            <>
                {
                    this.props.currentUser !== null ? this.props.children : null
                }
            </>
        );
    }
}

export default compose(withRouter, connect(
    state => state.applicationContext, dispatch => bindActionCreators({ ...applicationContextActionCreator }, dispatch)))(AssureContext);